import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import SuperAdminHeader from './../../components/Header/SuperAdmin';
import Footer from './../../components/Footer';
import { Modal, ModalBody } from 'reactstrap';
import Alert from './../../components/Errors/Alert'
import Select from 'react-select';
import Dialog from '../../components/Dialog/Dialog';

class DomainsAndCategories extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      domains: {},
      currentDomainId: null,
      newCategoryIsNotif: false,
      newCategoryName: '',
      newCategorySortIndex: '',
      newCategoryParent: null,
      newDomainCategoryImage: [],
      newCategoryModalOpen: false,
      deleteCategoryModalOpen: false,
      categoryToBeDeleted: {
        id: null,
        isNotif: null
      },
      categoryOptions: []
    }
    autobind(this)
  }
  componentDidMount() {
    this.props.getDomainsAndCategories()

  }

  populateCategoryParents() {
    const categoryOptions = this.state.domains[Object.keys(this.state.domains)[0]].categories.filter(category => category.parent == null).map((category) => {
        return { value: category.id, label: category.name };
    });

    this.setState({
      categoryOptions: categoryOptions
    })

  }

  componentWillReceiveProps(props) {
    this.setState({ domains: props.domains })
  }

  saveCategory(domainId, categoryId) {

    const categ = this.getCategoryById(domainId, categoryId)

    this.props.updateCategory(categ, this.props.getDomainsAndCategories)

  }

  getCategoryById(domainId, categoryId) {
    const { domains } = this.state

    return domains[domainId].categories.filter(category => category.id === categoryId)[0];
  }


  showNewCategoryModal(domainId, isNotif) {
    this.populateCategoryParents()
    this.setState({
      currentDomainId: domainId,
      newCategoryIsNotif: isNotif,
      newCategoryModalOpen: true
    })
  }

  toggleNewCategoryModalOpen() {
    this.setState({
      newCategoryModalOpen: !this.state.newCategoryModalOpen
    })
  }

  openDeleteCategoryModal(id, isNotif) {
    this.setState({
      deleteCategoryModalOpen: true,
      categoryToBeDeleted: {
        id: id,
        isNotif: isNotif
      }
    })
  }

  closeDeleteCategoryModal() {
    this.setState({
      deleteCategoryModalOpen: false,
      categoryToBeDeleted: {
        id: null,
        isNotif: null
      }
    })
  }


  updateCategInput(domainId, categoryId, name) {
    const { domains } = this.state
      , domain = domains[domainId]
      , categories = domain.categories.map((c, index) => c.id === categoryId ? Object.assign({}, c, { name }) : c)


    const updatedDomains = Object.assign({}, domains, { [domainId]: { ...domain, categories } })
    this.setState({
      domains: updatedDomains
    })
  }

  updateParentCategory(selectedOption){
    this.setState({
      newCategoryParent: selectedOption
    });
  }

  updateCategSortIndex(domainId, categoryId, sortIndex) {
    const { domains } = this.state
      , domain = domains[domainId]
      , categories = domain.categories.map((c, index) => c.id === categoryId ? Object.assign({}, c, { sortIndex }) : c)
    const updatedDomains = Object.assign({}, domains, { [domainId]: { ...domain, categories } })
    this.setState({
      domains: updatedDomains
    })
  }

  updateNewCategoryName(e) {
    this.setState({
      newCategoryName: e.target.value
    })
  }

  onDropNewDomainCategoryImage(accepted) {
    this.setState({
      newDomainCategoryImage: accepted[0]
    })
  }

  updateNewCategorySortIndex(e) {
    this.setState({
      newCategorySortIndex: e.target.value
    })
  }

  addNewDomainCategory() {
  console.log(this.state.newCategoryParent);
    this.props.addDomainCategory({
      domainId: this.state.currentDomainId,
      name: this.state.newCategoryName,
      sortIndex: this.state.newCategorySortIndex.length ? parseInt(this.state.newCategorySortIndex, 10) : null,
      image: this.state.newDomainCategoryImage ? this.state.newDomainCategoryImage : null,
      parent : this.state.newCategoryParent.value
    }, () => {
      this.props.getDomainsAndCategories()
      this.setState({
        newCategoryModalOpen: false,
        newDomainCategoryImage: null,
        newCategorySortIndex: '',
        newCategoryName: '',
        currentDomainId: null,
        newCategoryParent: null
      })
    })
  }

  addNewNotificationCategory() {
    this.props.addNotificationCategory({
      domain: this.state.currentDomainId,
      name: this.state.newCategoryName,
      sortIndex: this.state.newCategorySortIndex.length ? parseInt(this.state.newCategorySortIndex, 10) : null
    }, () => {
      this.props.getDomainsAndCategories()
      this.setState({
        newCategoryName: '',
        newCategorySortIndex: '',
        newCategoryModalOpen: false,
        currentDomainId: null
      })
    })
  }

  onDropCategoryImage(domainId, categoryId, accepted, rejected) {
    let pic = null
    if (accepted && accepted.length === 1) {
      pic = accepted[0]
    }
    const { domains } = this.state
      , domain = domains[domainId]
      , categories = domain.categories.map((c, index) => c.id === categoryId ? Object.assign({}, c, { acceptedUploadPicture: pic }) : c)
    const updatedDomains = Object.assign({}, domains, { [domainId]: { ...domain, categories } })

    this.setState({
      domains: updatedDomains
    })
  }

  deleteCategory(id, isNotif) {
    this.props.deleteCategory(id, isNotif);
    this.closeDeleteCategoryModal();
  }


  render() {
    const { domains } = this.state
      , sortedDomains = Object.keys(domains).map(did => domains[did]).sort((a, b) => a.sortIndex - b.sortIndex)


    const { error } = this.props

    return (
      <div className="superadmin">
        <SuperAdminHeader />
        <div className="container mt-5">
          <div className="row">
            {error ? <div className="col d-flex justify-content-center"><Alert message={error} /></div> : null}
            {sortedDomains.map(domain => {
              const { id: domainId, categories, isNotif } = domain
              return (
                <div key={domainId} className="col-12 mt-4">
                  <div className="d-flex justify-content-between mb-3">
                    <button className="btn btn-space btn-primary" onClick={() => { this.showNewCategoryModal(domainId, isNotif ? true : false) }}>
                      { isNotif ? "Add Notification Category" : "Add Collection or Category" }
                    </button>
                  </div>
                  {categories.filter(category => category.parent == null).map((category, categIndex) => {
                    const { id, name, sortIndex, categoryPath, acceptedUploadPicture, isNotif, productsCount, notificationsCount } = category
                      , picturePathOrUploaded = acceptedUploadPicture ? acceptedUploadPicture.preview : categoryPath

                    const itemsCount = isNotif ? notificationsCount : productsCount;
                    return (
                        <div className="mb-6" key={category.id} >
                      <div className="items-list-item d-flex justify-content-between align-items-stretch pl-4 pr-0">
                        <div className="d-flex justify-content-start align-items-center" style={{ flexGrow: 1 }}>
                          {!isNotif ? (
                            <div className="product-upload__image-container d-flex justify-content-center align-items-center flex-column">
                              <img src={picturePathOrUploaded} className="product-upload__image mb-4" alt="Category" style={{ maxWidth: 50 }} />
                              <Dropzone
                                onDrop={(accepted, rejected) => { this.onDropCategoryImage(domainId, category.id, accepted, rejected) }}
                                className="btn btn-rounded btn-space btn-secondary">
                                Upload New Image
                            </Dropzone>
                            </div>
                          ) : null}
                          <div className="list-item-1" style={{ flexGrow: 1 }}>
                            <input type="text" className="form-control form-control-xs" placeholder="Category name" value={name} onChange={(e) => this.updateCategInput(domainId, category.id, e.target.value)} />
                          </div>
                          <div className="list-item-1" style={{ flexGrow: 0.1 }}>
                            <input type="text" className="form-control form-control-xs" placeholder="Order" value={sortIndex} onChange={(e) => this.updateCategSortIndex(domainId, category.id, e.target.value)} />
                          </div>

                        </div>
                        <div className="list-item-6 list-item-actions" style={{ minHeight: isNotif ? 10 : 130 }}>
                          {true ? <span className="ar-icon s7-check" onClick={() => { this.saveCategory(domainId, category.id) }}></span> : "WIP"}
                          { itemsCount ? null : <span className="ar-icon s7-trash ml-3" onClick={() => { this.openDeleteCategoryModal(id, isNotif) }}></span> }
                        </div>
                      </div>

                          {categories.filter(subcategory => subcategory.parent === category.id).map((subcategory, subCategIndex) => {
                            const { id, name, sortIndex, categoryPath, acceptedUploadPicture, isNotif, productsCount, notificationsCount } = subcategory
                                , picturePathOrUploaded = acceptedUploadPicture ? acceptedUploadPicture.preview : categoryPath

                            const itemsCount = isNotif ? notificationsCount : productsCount;
                            return (
                                <div key={subcategory.id} className="items-list-item d-flex justify-content-between align-items-stretch ml-6 pl-4 pr-0">
                                  <div className="d-flex justify-content-start align-items-center" style={{ flexGrow: 1 }}>
                                    {!isNotif ? (
                                        <div className="product-upload__image-container d-flex justify-content-center align-items-center flex-column">
                                          <img src={picturePathOrUploaded} className="product-upload__image mb-4" alt="Category" style={{ maxWidth: 50 }} />
                                          <Dropzone
                                              onDrop={(accepted, rejected) => { this.onDropCategoryImage(domainId, subcategory.id, accepted, rejected) }}
                                              className="btn btn-rounded btn-space btn-secondary">
                                            Upload New Image
                                          </Dropzone>
                                        </div>
                                    ) : null}
                                    <div className="list-item-1" style={{ flexGrow: 1 }}>
                                      <input type="text" className="form-control form-control-xs" placeholder="Category name" value={name} onChange={(e) => this.updateCategInput(domainId, subcategory.id, e.target.value)} />
                                    </div>
                                    <div className="list-item-1" style={{ flexGrow: 0.1 }}>
                                      <input type="text" className="form-control form-control-xs" placeholder="Order" value={sortIndex} onChange={(e) => this.updateCategSortIndex(domainId, subcategory.id, e.target.value)} />
                                    </div>

                                  </div>
                                  <div className="list-item-6 list-item-actions" style={{ minHeight: 130 }}>
                                    {true ? <span className="ar-icon s7-check" onClick={() => { this.saveCategory(domainId, subcategory.id) }}></span> : "WIP"}
                                    { itemsCount ? null : <span className="ar-icon s7-trash ml-3" onClick={() => { this.openDeleteCategoryModal(id, isNotif) }}></span> }
                                  </div>
                                </div>
                            )
                          })}
                        </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
        <Modal isOpen={this.state.newCategoryModalOpen} toggle={this.toggleNewCategoryModalOpen} className="modal-md notif-modal superadmin">
          <div className="modal-header">
            <div className="d-flex flex-row justify-content-between align-items-start w-100 mb-4 p-4">
              <div>
                <h3 className="mb-1">Create New category</h3>
              </div>
              <h3>
                <div onClick={this.toggleNewCategoryModalOpen} className="s7-close modal-close"></div>
              </h3>
            </div>
          </div>
          <ModalBody className="pt-0">
            {/* {error ? <Alert message={error} /> : null} */}
            <label className="mt-3">Category name</label>
            <input type="text" placeholder="Name" className="form-control form-control-xs mb-4" value={this.state.newCategoryName} onChange={this.updateNewCategoryName} />

            <label className="mt-3">Category Parent</label>
            <Select
                name="category-parent"
                className="advanced-select"
                value={this.state.newCategoryParent}
                onChange={this.updateParentCategory}
                options={this.state.categoryOptions}
            />

            <label className="mt-4">Sort index</label>
            <input type="number" placeholder="Index" className="form-control form-control-xs mb-4" value={this.state.newCategorySortIndex} onChange={this.updateNewCategorySortIndex} />


            {this.state.newCategoryIsNotif ? '' : (
              <div className="d-flex align-items-center mb-4">
                <label className="mr-5 mb-5 text-md">Category photo</label>
                <div className="d-flex justify-content-center mb-0 mr-3">
                  <Dropzone
                    onDrop={(accepted, rejected) => { this.onDropNewDomainCategoryImage(accepted, rejected) }}
                    className="btn btn-rounded btn-space btn-secondary">
                    Upload from Computer
                </Dropzone>
                </div>
                <label>{this.state.newDomainCategoryImage ? this.state.newDomainCategoryImage.name : 'None'}</label>
              </div>
            )}
            <button className="btn btn-space btn-primary" onClick={() => { this.state.newCategoryIsNotif ? this.addNewNotificationCategory() : this.addNewDomainCategory() }}>Add New Category</button>
          </ModalBody>
        </Modal>
        <Dialog 
          open={this.state.deleteCategoryModalOpen} 
          proceed={() => this.deleteCategory(this.state.categoryToBeDeleted.id, this.state.categoryToBeDeleted.isNotif)}
          cancel={this.closeDeleteCategoryModal}
          message="If you delete this category you won't be able to retrieve the data."
          />
        <Footer />
      </div>
    )
  }
}

export default connect(
  (state, ownProps) => {
    const { domains } = state
    return { domains: domains.all, error: domains.error }
  },
  actions,
  (stateProps, dispatchProps) => {
    return Object.assign({}, stateProps, dispatchProps)
  }
)(withRouter(DomainsAndCategories))


// WEBPACK FOOTER //
// ./src/containers/SuperAdmin/SuperAdminDomains.js